import { IHeroProgressionState } from "@/store/apis/heroAPI/hero.types"

export enum MOB_STATUS {
  ALIVE = "ALIVE",
  IN_COMBAT = "IN_COMBAT"
}

export enum MOB_ACTION_DENIAL_REASON {
  PLAYER_MOVING = "PLAYER_MOVING",
  NOT_ON_CELL = "NOT_ON_CELL",
  ENGAGEMENT_OPEN = "ENGAGEMENT_OPEN",
  NO_FREE_MOB = "NO_FREE_MOB",
  ENGAGEMENT_CLOSED = "ENGAGEMENT_CLOSED",
  ACTION_RETRY_EXHAUSTED = "ACTION_RETRY_EXHAUSTED"
}

export enum MOB_LEAVE_OUTCOME {
  RELEASED = "RELEASED"
}

export interface IMobCellRow {
  id: string
  typeCode: string
  level: number
  status: MOB_STATUS
  version: number
}

export interface IMobCellResponse {
  mobs: IMobCellRow[]
}

export interface IGetCellMobsReq {
  mapId: string
  x: number
  y: number
}

export interface IGetMobCardReq {
  typeCode: string
  level: number
}

export interface IMobStatValue {
  statCode: string
  value: number
}

export interface IMobDollItem {
  position: string
  itemCode: string
  rarityCode: string
}

export interface IMobLootRow {
  itemCode: string
  rarityCode: string
  quantityMin: number
  quantityMax: number
}

export interface IMobCurrencyLootRow {
  currencyCode: string
  amountMin: string
  amountMax: string
}

export interface IMobCard {
  typeCode: string
  level: number
  stats: IMobStatValue[]
  doll: IMobDollItem[]
  loot: IMobLootRow[]
  currencyLoot: IMobCurrencyLootRow[]
}

export interface IMobEngagement {
  id: string
  mobId: string
  typeCode: string
  level: number
  mapId: string
  x: number
  y: number
  startedAt: string
}

export interface IOpenEngagementResponse {
  engagement: IMobEngagement | null
}

export interface IMobKillDrop {
  itemCode: string
  rarityCode: string
  quantity: number
}

export interface IMobKillCurrencyDrop {
  currencyCode: string
  amount: string
}

export interface IMobKill {
  id: string
  typeCode: string
  level: number
  mapId: string
  x: number
  y: number
  killedAt: string
  xpGranted: number
  drops: IMobKillDrop[]
  currencyDrops: IMobKillCurrencyDrop[]
}

export interface IMobWinResponse {
  kill: IMobKill
  hero: IHeroProgressionState | null
}

export interface IMobActionDenialBody {
  statusCode: number
  message: string
  reason: MOB_ACTION_DENIAL_REASON
  timestamp: string
}

export interface IMobAttackRequest {
  mapId: string
  x: number
  y: number
  typeCode: string
  level: number
}

export interface IMobLeaveResponse {
  engagementId: string
  outcome: MOB_LEAVE_OUTCOME
}

export interface IMobRedistributeRequest {
  mapId: string
}

export interface IMobRedistributeResponse {
  mapId: string
  placed: number
  removed: number
  detached: number
  warnings: string[]
}

export interface IMobTypeLevel {
  level: number
  archived: boolean
}

export interface IMobType {
  code: string
  archived: boolean
  levels: IMobTypeLevel[]
}

export interface IMobTypeListResponse {
  types: IMobType[]
}
